import instance from "./request";


//项目查询
export const projectPage = (data) => instance.get('/project/page', data)
//新增项目
export const addProject = (data) => instance.post('/project/add', data)
//修改项目
export const editProject = (data) => instance.post('/project/edit', data)
//项目详情
export const projectInfo = (id) => instance.get('/project/info/' + id)


//新增账号
export const addUser = (data) => instance.post('/user/add', data)
//修改账号
export const editUser = (data) => instance.post('/user/edit', data)
//账号详情
export const userInfo = (id) => instance.get('/user/info/' + id)


//所有角色
export const roleAll = (project_id) => instance.post('/role/all', { project_id: project_id })



//新增账号
export const addRole = (data) => instance.post('/role/add', data)
//修改账号
export const editRole = (data) => instance.post('/role/edit', data)
//账号详情
export const roleInfo = (id) => instance.get('/role/info/' + id)


//新增菜单
export const addMenu = (data) => instance.post('/menu/add', data)
//修改菜单
export const editMenu = (data) => instance.post('/menu/edit', data)
//菜单详情
export const menuInfo = (id) => instance.get('/menu/info/' + id)
//所有菜单
export const menuAll = () => instance.get('/menu/all')

//上传文件
export const upload = (data) => instance.post('/upload', data, {
    headers: {
        "Content-Type": 'multipart/form-data;charset=utf-8'
    },
})